import { useSelector } from "react-redux";
import {
  clearTeachersFilters,
  getSelectedDepartments,
  getSelectedFaculties,
  getTeachersFiltersCount,
  setSelectedDepartments,
  setSelectedFaculties,
} from "../../services/teachers/teachersSlice";
import { useAppDispatch } from "../../hooks/redux";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import DepartmentsFilter from "../../components/filters/DepartmentsFilter";
import FacultyFilter from "../../components/filters/FacultyFilter";

const ContextSidebar = (props: any) => {
  const teachersFiltersCount = useSelector(getTeachersFiltersCount);
  const dispatch = useAppDispatch();

  const handleClearFilters = () => {
    dispatch(clearTeachersFilters());
  };

  return (
    <Panel
      header="Филтриране на преподаватели"
      className="w-full mt-4 shadow-4"
      pt={{
        header: {
          className: "text-xl surface-ground font-light",
        },
      }}
      {...props}
    >
      {teachersFiltersCount > 0 ? (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">{teachersFiltersCount} активни филтъра.</p>
          <Button
            label="Изчисти филтрите"
            icon="pi pi-times"
            severity="danger"
            outlined
            size="small"
            className="w-50 mb-4"
            onClick={handleClearFilters}
          />
        </div>
      ) : (
        <div className="h-5rem">
          <p className="text-sm text-gray-500">Няма активни филтри.</p>
          <div className="pi pi-sparkles pi-spin"></div>
        </div>
      )}

      <FacultyFilter getSelectedFaculties={getSelectedFaculties} setSelectedFaculties={setSelectedFaculties} />
      <DepartmentsFilter
        getSelectedDepartments={getSelectedDepartments}
        setSelectedDepartments={setSelectedDepartments}
      />
    </Panel>
  );
};

export default ContextSidebar;
